import { render, staticRenderFns } from "./getFreeCourse.vue?vue&type=template&id=199ccbaf&scoped=true&"
import script from "./getFreeCourse.vue?vue&type=script&lang=js&"
export * from "./getFreeCourse.vue?vue&type=script&lang=js&"
import style0 from "./getFreeCourse.vue?vue&type=style&index=0&id=199ccbaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ccbaf",
  null
  
)

export default component.exports